export const getNestedCategory = (category: string): number =>
  (String(category) || '').split(':').length;

export default getNestedCategory;
